import React, { useEffect } from "react";
import queryString from 'query-string'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// core components
import { Col, Container, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"

// Import the new form component
import PasswordResetForm from "components/Forms/PasswordResetForm/PasswordResetForm";

const PasswordResetView = () => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleModalConfirm = () => {
    // navigate("/dashboard/users");
  }
  
  const handleResolve = () => {
    notify({ title:t("Käyttäjä"), message:t("Uusi salasana asetettu. Voit nyt kirjautua sisään")})
    handleModalConfirm();
  }
  
  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed?.token) {
      localStorage.removeItem("refreshToken");
      localStorage.setItem("accessToken", parsed?.token);
    }
  },[location])
  
  return (
    <>
      <Container className="mt-4 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="7" className="">
            <PasswordResetForm 
              history={navigate} 
              t={t} 
              handleResolve={handleResolve} 
              notify={notify} 
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default PasswordResetView;
